// ----------------------------------------------------------------------------
// Component: Press Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Thumbs, A11y, Keyboard, FreeMode } from 'swiper';
import './_press-block.scss';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/thumbs';

// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SECTION_SELECTOR = '.press-block';
const CAROUSEL_SELECTOR = '.carousel--press-block-quotes';
const CAROUSEL_CLASS = 'carousel--press-block-quotes';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';

const CAROUSEL_THUMBNAIL_SELECTOR = '.carousel--press-block-logos';
const CAROUSEL_THUMBNAIL = 'carousel--press-block-logos';


// -------------------------------------
// Helpers
// -------------------------------------
const initPressBlockSwiper = (element, index) => {
    // Generate unique class for each quote slider
    element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

    // Generate unique btn classes for slider arrows
    element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_CLASS}-btn-prev-${index}`);
    element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_CLASS}-btn-next-${index}`);

    // Generate unique class for each logo thumbnail slider
    element.querySelector(CAROUSEL_THUMBNAIL_SELECTOR).classList.add(`${CAROUSEL_THUMBNAIL}-${index}`);

    const swiperThumbnail = new Swiper(`.${CAROUSEL_THUMBNAIL}-${index}`, {
        modules: [FreeMode, A11y, Keyboard],
        slidesPerView: 5,
        spaceBetween: 10,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        keyboard: {
            enabled: false
        },
        a11y: false,
        multipleActiveThumbs: false,
        watchOverflow: false, // Do not turn into sliders if number of slides is less than slidesPerView.
    });

    const swiperQuote = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
        // Optional parameters
        modules: [Navigation, Thumbs, A11y, Keyboard],
        slidesPerView: 1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
        thumbs: {
            swiper: swiperThumbnail.$el ? swiperThumbnail : null,
        },
        // Navigation arrows
        navigation: {
            nextEl: `.${CAROUSEL_CLASS}-btn-next-${index}`,
            prevEl: `.${CAROUSEL_CLASS}-btn-prev-${index}`
        },
        // autoplay: {
        //     delay: 2500,
        //     disableOnInteraction: false,
        // },
    });

    swiperQuote.slides.forEach(function(slide, index) {
        const slideLink = slide.querySelector('a');
        if(slideLink != null) {
            slideLink.addEventListener('focus', function(e) {
                swiperQuote.slideTo(index);
            });
        }
    });

    swiperThumbnail.slides.each((slide) => {
        slide.addEventListener('focus', function(e) {
            const slideIndex = slide.getAttribute('data-index');
            slideToSlide(swiperThumbnail, slideIndex, true);
            slideToSlide(swiperQuote, slideIndex, true);

            swiperThumbnail.slides.each(function(thumbnailSlide) {
                thumbnailSlide.setAttribute('tabindex', '0');
            });
        });
        slide.addEventListener('keydown', (e) => {
            if (e.key === "Enter") {
                swiperThumbnail.slides.each(function(thumbnailSlide) {
                    thumbnailSlide.setAttribute('tabindex', '-1');
                });
                slide.setAttribute('tabindex', '0');
                const slideIndex = parseInt(slide.getAttribute('data-index'));
                swiperQuote.slides[slideIndex].focus();
            }
        });
    });
};

const slideToSlide = (slider, slideIndex, transition) => {
    if (transition) {
        slider.slideTo(slideIndex);
    } else {
        slider.slideTo(slideIndex, 0);
    }
};

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const PressBlocks = document.querySelectorAll(CAROUSEL_SECTION_SELECTOR);

    PressBlocks.forEach((PressBlock, index) => {
        initPressBlockSwiper(PressBlock, index);
    });
});
